import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-password\">\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" transform=\"translate(50,50) scale(1.2) translate(-50,-50)\">\n    <circle cx=\"65\" cy=\"35\" r=\"20\" />\n    <line x1=\"51\" y1=\"49\" x2=\"20\" y2=\"80\" />\n    <line x1=\"38\" y1=\"62\" x2=\"45\" y2=\"69\" />\n    <line x1=\"28\" y1=\"72\" x2=\"35\" y2=\"79\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/password.svg
// module id = QjmH
// module chunks = 212